import PostfullyIcon from '@/assets/postfully-icon.svg?react'
import {
  SupportDialog,
  SupportDialogPopup,
  SupportDialogTrigger,
} from '@/components/support-dialog'
import { Button } from '@beeirl/ui/button'
import { cn } from '@beeirl/ui/utils/cn'
import React from 'react'

export function Header() {
  const ref = React.useRef<HTMLDivElement>(null)

  const [border, setBorder] = React.useState(false)

  React.useEffect(() => {
    function toggleBorder() {
      if (!ref.current) return
      setBorder(ref.current.getBoundingClientRect().top === -12)
    }
    toggleBorder()
    window.addEventListener('scroll', toggleBorder)
    return () => window.removeEventListener('scroll', toggleBorder)
  }, [])

  return (
    <div
      className={cn(
        'sticky -top-3 z-50 border-b border-transparent bg-white pb-2 pt-5',
        border && 'border-gray-100'
      )}
      ref={ref}
    >
      <nav className="relative mx-auto flex w-full max-w-5xl items-center justify-between px-8 md:px-12 lg:px-16">
        <div className="text-lg font-bold">
          <a className="relative flex items-center gap-2" href="/">
            <PostfullyIcon className="size-5" />
            <span className="font-semibold text-gray-900">Postfully</span>
          </a>
        </div>
        <div className="flex gap-4">
          <SupportDialog>
            <SupportDialogTrigger
              render={
                <Button className="font-semibold" color="gray" highContrast variant="ghost">
                  Support
                </Button>
              }
            />
            <SupportDialogPopup location="header" />
          </SupportDialog>
          <Button
            className="font-semibold"
            color="gray"
            highContrast
            variant="ghost"
            render={<a href="/">All Tools</a>}
          />
        </div>
      </nav>
    </div>
  )
}
